export const RELAY_ENFORCEMENT = {
    NONE: 'NONE',
    WARNING: 'WARNING',
    BLOCKING: 'BLOCKING',
    BLOCKING_WITHOUT_WARNING: 'BLOCKING_WITHOUT_WARNING',
};

export const DEFAULT_RELAY_ENFORCEMENT = RELAY_ENFORCEMENT.WARNING;

const KNOWN_STATUSES = new Set(Object.values(RELAY_ENFORCEMENT));
const WARNING_STATUSES = [RELAY_ENFORCEMENT.WARNING, RELAY_ENFORCEMENT.BLOCKING];
const BLOCKING_STATUSES = [RELAY_ENFORCEMENT.BLOCKING, RELAY_ENFORCEMENT.BLOCKING_WITHOUT_WARNING];

export const normalizeRelayEnforcement = (relayEnforcement) => (KNOWN_STATUSES.has(relayEnforcement) ? relayEnforcement : DEFAULT_RELAY_ENFORCEMENT);

export const showsRelayWarning = (relayEnforcement) => WARNING_STATUSES.includes(normalizeRelayEnforcement(relayEnforcement));

export const blocksRelaySubmit = (relayEnforcement) => BLOCKING_STATUSES.includes(normalizeRelayEnforcement(relayEnforcement));

export const resolveRelayEnforcementFromRelaysConfig = (relaysConfig) => normalizeRelayEnforcement(relaysConfig?.[0]?.relayEnforcement);
